module.exports = __webpack_public_path__ + "static/media/hcfamemalogo3.de50a09e.png";